
/**
 * Custom image renderer for timetable view
 *
 * Props received from GDImageViewer:
 * - item:        { id, name, modifiedTime }
 * - openSrc:     (id, large?) => string URL
 * - onClick:     () => void
 * - showDate:    boolean
 * - attachClass: { [filename]: string }
 * - attachId:    { [filename]: string }
 */
export default function TimeTableImage({
  item,
  openSrc,
  onClick,
  showDate,
  attachClass = {},
  attachId = {},
}) {
  const { id, name, modifiedTime } = item;

  // format date if enabled
  const formattedDate =
    showDate && modifiedTime
      ? new Date(modifiedTime).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
      : "";

  return (
    <div className="timeTableWrapper">
     <div className="timeBadge">
        {formattedDate && (
          <h4 className="">{formattedDate}</h4>
        )}
      </div>
    <div className="gd-thumb-wrapper">
     
      <img
        src={openSrc(id)}
        alt={name}
        className={`timetable-img ${attachClass[name] || ""}`.trim()}
        id={attachId[name] ?? undefined}
        onClick={onClick}
      />
    </div>
    </div>
  );
}
